import {SecuritySettings} from "./security-settings";
import {Utils} from "../../../shared/utils/utils";

export class SecuritySettingsMapper {

  public static map(data: any): SecuritySettings {
    const settingsData: any = data && data.scan && data.scan.scans ? data.scan.scans : {};

    const securitySettings: SecuritySettings = new SecuritySettings();

    /*securitySettings.wordpressVulnerabilities = Utils.isTruthy(settingsData.core_vulnerabilities);
    securitySettings.pluginsVulnerabilities = Utils.isTruthy(settingsData.plugin_vulnerabilities);*/
    securitySettings.coreFilesChanges = Utils.isTruthy(settingsData.core_issues);
    securitySettings.pluginFilesChanges = Utils.isTruthy(settingsData.plugin_issues);
    securitySettings.themeFilesChanges = Utils.isTruthy(settingsData.theme_issues);

    return securitySettings;
  }

  public static generateRequestData(data: any): any {
    const securitySettingsData: any = {
      'name': 'scan',
      'settings': {
        'scans': {
          /*'core_vulnerabilities': data.wordpressVulnerabilities ? '1' : '0',
          'plugin_vulnerabilities': data.pluginsVulnerabilities ? '1' : '0',*/
          'core_issues': data.coreFilesChanges ? '1' : '0',
          'plugin_issues': data.pluginFilesChanges ? '1' : '0',
          'theme_issues': data.themeFilesChanges ? '1' : '0',
        }
      }
    };

    return securitySettingsData;
  }

  public static mapResponseData(data: any): any {
    const securitySettingsData: any = {
      'scan': {
        'scans': {
          'core_issues': data.coreFilesChanges ? '1' : '0',
          'plugin_issues': data.pluginFilesChanges ? '1' : '0',
          'theme_issues': data.themeFilesChanges ? '1' : '0',
        }
      }
    };

    return securitySettingsData;
  }

}
